import { Action, createReducer, on } from '@ngrx/store';
import * as ImageActions from '../actions/image.actions';

export const imageFeatureKey = 'image';

export interface State {
  profileImage: string
}

export const initialState: State = {
  profileImage: null
};

export const reducer = createReducer(
  initialState,

  on(ImageActions.loadProfileImage, state => state),
  on(ImageActions.loadProfileImageSuccess, (state, { image }) => ({
    ...state,
    profileImage: image
  })),
  on(ImageActions.loadProfileImageFailure, (state, action) => state),
  on(ImageActions.storeProfileImageSuccess, (state, { image }) => ({
    ...state,
    profileImage: image
  })),
  on(ImageActions.storeProfileImageSuccess, (state, action) => state),
  on(ImageActions.storeProfileImageFailure, (state, action) => state),
  on(ImageActions.removeProfileImageSuccess, (state, { image }) => ({
    ...state,
    profileImage: image
  })),

);
